import { render, staticRenderFns } from "./AuthorizedClients.vue?vue&type=template&id=177d300e&scoped=true&"
import script from "./AuthorizedClients.vue?vue&type=script&lang=js&"
export * from "./AuthorizedClients.vue?vue&type=script&lang=js&"
import style0 from "./AuthorizedClients.vue?vue&type=style&index=0&id=177d300e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "177d300e",
  null
  
)

export default component.exports